/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_Issued_BtnInputs */

const vi_einvoice_pending_issued_btn = /** @type {(inputs: Einvoice_Pending_Issued_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất trên MISA`)
};

/**

* @param {Einvoice_Pending_Issued_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_issued_btn = /** @type {((inputs?: Einvoice_Pending_Issued_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_Issued_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_issued_btn(inputs)
});